/**
 * 中国省市二级联动数据
 * 提供完整的中国省市数据，支持多种格式输出
 */

// 省市数据结构
const chinaCityData = {
  // 省级数据
  provinces: [
    { id: '110000', name: '北京市', shortName: '北京' },
    { id: '120000', name: '天津市', shortName: '天津' },
    { id: '130000', name: '河北省', shortName: '河北' },
    { id: '140000', name: '山西省', shortName: '山西' },
    { id: '150000', name: '内蒙古自治区', shortName: '内蒙古' },
    { id: '210000', name: '辽宁省', shortName: '辽宁' },
    { id: '220000', name: '吉林省', shortName: '吉林' },
    { id: '230000', name: '黑龙江省', shortName: '黑龙江' },
    { id: '310000', name: '上海市', shortName: '上海' },
    { id: '320000', name: '江苏省', shortName: '江苏' },
    { id: '330000', name: '浙江省', shortName: '浙江' },
    { id: '340000', name: '安徽省', shortName: '安徽' },
    { id: '350000', name: '福建省', shortName: '福建' },
    { id: '360000', name: '江西省', shortName: '江西' },
    { id: '370000', name: '山东省', shortName: '山东' },
    { id: '410000', name: '河南省', shortName: '河南' },
    { id: '420000', name: '湖北省', shortName: '湖北' },
    { id: '430000', name: '湖南省', shortName: '湖南' },
    { id: '440000', name: '广东省', shortName: '广东' },
    { id: '450000', name: '广西壮族自治区', shortName: '广西' },
    { id: '460000', name: '海南省', shortName: '海南' },
    { id: '500000', name: '重庆市', shortName: '重庆' },
    { id: '510000', name: '四川省', shortName: '四川' },
    { id: '520000', name: '贵州省', shortName: '贵州' },
    { id: '530000', name: '云南省', shortName: '云南' },
    { id: '540000', name: '西藏自治区', shortName: '西藏' },
    { id: '610000', name: '陕西省', shortName: '陕西' },
    { id: '620000', name: '甘肃省', shortName: '甘肃' },
    { id: '630000', name: '青海省', shortName: '青海' },
    { id: '640000', name: '宁夏回族自治区', shortName: '宁夏' },
    { id: '650000', name: '新疆维吾尔自治区', shortName: '新疆' },
    { id: '710000', name: '台湾省', shortName: '台湾' },
    { id: '810000', name: '香港特别行政区', shortName: '香港' },
    { id: '820000', name: '澳门特别行政区', shortName: '澳门' }
  ],

  // 市级数据（部分主要城市示例）
  cities: {
    '110000': [
      { id: '110100', name: '北京市', parentId: '110000', shortName: '北京' }
    ],
    '120000': [
      { id: '120100', name: '天津市', parentId: '120000', shortName: '天津' }
    ],
    '130000': [
      { id: '130100', name: '石家庄市', parentId: '130000', shortName: '石家庄' },
      { id: '130200', name: '唐山市', parentId: '130000', shortName: '唐山' },
      { id: '130300', name: '秦皇岛市', parentId: '130000', shortName: '秦皇岛' },
      { id: '130400', name: '邯郸市', parentId: '130000', shortName: '邯郸' },
      { id: '130500', name: '邢台市', parentId: '130000', shortName: '邢台' },
      { id: '130600', name: '保定市', parentId: '130000', shortName: '保定' },
      { id: '130700', name: '张家口市', parentId: '130000', shortName: '张家口' },
      { id: '130800', name: '承德市', parentId: '130000', shortName: '承德' },
      { id: '130900', name: '沧州市', parentId: '130000', shortName: '沧州' },
      { id: '131000', name: '廊坊市', parentId: '130000', shortName: '廊坊' },
      { id: '131100', name: '衡水市', parentId: '130000', shortName: '衡水' }
    ],
    '140000': [
      { id: '140100', name: '太原市', parentId: '140000', shortName: '太原' },
      { id: '140200', name: '大同市', parentId: '140000', shortName: '大同' },
      { id: '140300', name: '阳泉市', parentId: '140000', shortName: '阳泉' },
      { id: '140400', name: '长治市', parentId: '140000', shortName: '长治' },
      { id: '140500', name: '晋城市', parentId: '140000', shortName: '晋城' },
      { id: '140600', name: '朔州市', parentId: '140000', shortName: '朔州' },
      { id: '140700', name: '晋中市', parentId: '140000', shortName: '晋中' },
      { id: '140800', name: '运城市', parentId: '140000', shortName: '运城' },
      { id: '140900', name: '忻州市', parentId: '140000', shortName: '忻州' },
      { id: '141000', name: '临汾市', parentId: '140000', shortName: '临汾' },
      { id: '141100', name: '吕梁市', parentId: '140000', shortName: '吕梁' }
    ],
    '150000': [
      { id: '150100', name: '呼和浩特市', parentId: '150000', shortName: '呼和浩特' },
      { id: '150200', name: '包头市', parentId: '150000', shortName: '包头' },
      { id: '150300', name: '乌海市', parentId: '150000', shortName: '乌海' },
      { id: '150400', name: '赤峰市', parentId: '150000', shortName: '赤峰' },
      { id: '150500', name: '通辽市', parentId: '150000', shortName: '通辽' },
      { id: '150600', name: '鄂尔多斯市', parentId: '150000', shortName: '鄂尔多斯' },
      { id: '150700', name: '呼伦贝尔市', parentId: '150000', shortName: '呼伦贝尔' },
      { id: '150800', name: '巴彦淖尔市', parentId: '150000', shortName: '巴彦淖尔' },
      { id: '150900', name: '乌兰察布市', parentId: '150000', shortName: '乌兰察布' },
      { id: '152200', name: '兴安盟', parentId: '150000', shortName: '兴安盟' },
      { id: '152500', name: '锡林郭勒盟', parentId: '150000', shortName: '锡林郭勒' },
      { id: '152900', name: '阿拉善盟', parentId: '150000', shortName: '阿拉善' }
    ],
    '210000': [
      { id: '210100', name: '沈阳市', parentId: '210000', shortName: '沈阳' },
      { id: '210200', name: '大连市', parentId: '210000', shortName: '大连' },
      { id: '210300', name: '鞍山市', parentId: '210000', shortName: '鞍山' },
      { id: '210400', name: '抚顺市', parentId: '210000', shortName: '抚顺' },
      { id: '210500', name: '本溪市', parentId: '210000', shortName: '本溪' },
      { id: '210600', name: '丹东市', parentId: '210000', shortName: '丹东' },
      { id: '210700', name: '锦州市', parentId: '210000', shortName: '锦州' },
      { id: '210800', name: '营口市', parentId: '210000', shortName: '营口' },
      { id: '210900', name: '阜新市', parentId: '210000', shortName: '阜新' },
      { id: '211000', name: '辽阳市', parentId: '210000', shortName: '辽阳' },
      { id: '211100', name: '盘锦市', parentId: '210000', shortName: '盘锦' },
      { id: '211200', name: '铁岭市', parentId: '210000', shortName: '铁岭' },
      { id: '211300', name: '朝阳市', parentId: '210000', shortName: '朝阳' },
      { id: '211400', name: '葫芦岛市', parentId: '210000', shortName: '葫芦岛' }
    ],
    '220000': [
      { id: '220100', name: '长春市', parentId: '220000', shortName: '长春' },
      { id: '220200', name: '吉林市', parentId: '220000', shortName: '吉林' },
      { id: '220300', name: '四平市', parentId: '220000', shortName: '四平' },
      { id: '220400', name: '辽源市', parentId: '220000', shortName: '辽源' },
      { id: '220500', name: '通化市', parentId: '220000', shortName: '通化' },
      { id: '220600', name: '白山市', parentId: '220000', shortName: '白山' },
      { id: '220700', name: '松原市', parentId: '220000', shortName: '松原' },
      { id: '220800', name: '白城市', parentId: '220000', shortName: '白城' },
      { id: '222400', name: '延边朝鲜族自治州', parentId: '220000', shortName: '延边' }
    ],
    '230000': [
      { id: '230100', name: '哈尔滨市', parentId: '230000', shortName: '哈尔滨' },
      { id: '230200', name: '齐齐哈尔市', parentId: '230000', shortName: '齐齐哈尔' },
      { id: '230300', name: '鸡西市', parentId: '230000', shortName: '鸡西' },
      { id: '230400', name: '鹤岗市', parentId: '230000', shortName: '鹤岗' },
      { id: '230500', name: '双鸭山市', parentId: '230000', shortName: '双鸭山' },
      { id: '230600', name: '大庆市', parentId: '230000', shortName: '大庆' },
      { id: '230700', name: '伊春市', parentId: '230000', shortName: '伊春' },
      { id: '230800', name: '佳木斯市', parentId: '230000', shortName: '佳木斯' },
      { id: '230900', name: '七台河市', parentId: '230000', shortName: '七台河' },
      { id: '231000', name: '牡丹江市', parentId: '230000', shortName: '牡丹江' },
      { id: '231100', name: '黑河市', parentId: '230000', shortName: '黑河' },
      { id: '231200', name: '绥化市', parentId: '230000', shortName: '绥化' },
      { id: '232700', name: '大兴安岭地区', parentId: '230000', shortName: '大兴安岭' }
    ],
    '310000': [
      { id: '310100', name: '上海市', parentId: '310000', shortName: '上海' }
    ],
    '320000': [
      { id: '320100', name: '南京市', parentId: '320000', shortName: '南京' },
      { id: '320200', name: '无锡市', parentId: '320000', shortName: '无锡' },
      { id: '320300', name: '徐州市', parentId: '320000', shortName: '徐州' },
      { id: '320400', name: '常州市', parentId: '320000', shortName: '常州' },
      { id: '320500', name: '苏州市', parentId: '320000', shortName: '苏州' },
      { id: '320600', name: '南通市', parentId: '320000', shortName: '南通' },
      { id: '320700', name: '连云港市', parentId: '320000', shortName: '连云港' },
      { id: '320800', name: '淮安市', parentId: '320000', shortName: '淮安' },
      { id: '320900', name: '盐城市', parentId: '320000', shortName: '盐城' },
      { id: '321000', name: '扬州市', parentId: '320000', shortName: '扬州' },
      { id: '321100', name: '镇江市', parentId: '320000', shortName: '镇江' },
      { id: '321200', name: '泰州市', parentId: '320000', shortName: '泰州' },
      { id: '321300', name: '宿迁市', parentId: '320000', shortName: '宿迁' }
    ],
    '330000': [
      { id: '330100', name: '杭州市', parentId: '330000', shortName: '杭州' },
      { id: '330200', name: '宁波市', parentId: '330000', shortName: '宁波' },
      { id: '330300', name: '温州市', parentId: '330000', shortName: '温州' },
      { id: '330400', name: '嘉兴市', parentId: '330000', shortName: '嘉兴' },
      { id: '330500', name: '湖州市', parentId: '330000', shortName: '湖州' },
      { id: '330600', name: '绍兴市', parentId: '330000', shortName: '绍兴' },
      { id: '330700', name: '金华市', parentId: '330000', shortName: '金华' },
      { id: '330800', name: '衢州市', parentId: '330000', shortName: '衢州' },
      { id: '330900', name: '舟山市', parentId: '330000', shortName: '舟山' },
      { id: '331000', name: '台州市', parentId: '330000', shortName: '台州' },
      { id: '331100', name: '丽水市', parentId: '330000', shortName: '丽水' }
    ],
    '340000': [
      { id: '340100', name: '合肥市', parentId: '340000', shortName: '合肥' },
      { id: '340200', name: '芜湖市', parentId: '340000', shortName: '芜湖' },
      { id: '340300', name: '蚌埠市', parentId: '340000', shortName: '蚌埠' },
      { id: '340400', name: '淮南市', parentId: '340000', shortName: '淮南' },
      { id: '340500', name: '马鞍山市', parentId: '340000', shortName: '马鞍山' },
      { id: '340600', name: '淮北市', parentId: '340000', shortName: '淮北' },
      { id: '340700', name: '铜陵市', parentId: '340000', shortName: '铜陵' },
      { id: '340800', name: '安庆市', parentId: '340000', shortName: '安庆' },
      { id: '341000', name: '黄山市', parentId: '340000', shortName: '黄山' },
      { id: '341100', name: '滁州市', parentId: '340000', shortName: '滁州' },
      { id: '341200', name: '阜阳市', parentId: '340000', shortName: '阜阳' },
      { id: '341300', name: '宿州市', parentId: '340000', shortName: '宿州' },
      { id: '341500', name: '六安市', parentId: '340000', shortName: '六安' },
      { id: '341600', name: '亳州市', parentId: '340000', shortName: '亳州' },
      { id: '341700', name: '池州市', parentId: '340000', shortName: '池州' },
      { id: '341800', name: '宣城市', parentId: '340000', shortName: '宣城' }
    ],
    '350000': [
      { id: '350100', name: '福州市', parentId: '350000', shortName: '福州' },
      { id: '350200', name: '厦门市', parentId: '350000', shortName: '厦门' },
      { id: '350300', name: '莆田市', parentId: '350000', shortName: '莆田' },
      { id: '350400', name: '三明市', parentId: '350000', shortName: '三明' },
      { id: '350500', name: '泉州市', parentId: '350000', shortName: '泉州' },
      { id: '350600', name: '漳州市', parentId: '350000', shortName: '漳州' },
      { id: '350700', name: '南平市', parentId: '350000', shortName: '南平' },
      { id: '350800', name: '龙岩市', parentId: '350000', shortName: '龙岩' },
      { id: '350900', name: '宁德市', parentId: '350000', shortName: '宁德' }
    ],
    '360000': [
      { id: '360100', name: '南昌市', parentId: '360000', shortName: '南昌' },
      { id: '360200', name: '景德镇市', parentId: '360000', shortName: '景德镇' },
      { id: '360300', name: '萍乡市', parentId: '360000', shortName: '萍乡' },
      { id: '360400', name: '九江市', parentId: '360000', shortName: '九江' },
      { id: '360500', name: '新余市', parentId: '360000', shortName: '新余' },
      { id: '360600', name: '鹰潭市', parentId: '360000', shortName: '鹰潭' },
      { id: '360700', name: '赣州市', parentId: '360000', shortName: '赣州' },
      { id: '360800', name: '吉安市', parentId: '360000', shortName: '吉安' },
      { id: '360900', name: '宜春市', parentId: '360000', shortName: '宜春' },
      { id: '361000', name: '抚州市', parentId: '360000', shortName: '抚州' },
      { id: '361100', name: '上饶市', parentId: '360000', shortName: '上饶' }
    ],
    '370000': [
      { id: '370100', name: '济南市', parentId: '370000', shortName: '济南' },
      { id: '370200', name: '青岛市', parentId: '370000', shortName: '青岛' },
      { id: '370300', name: '淄博市', parentId: '370000', shortName: '淄博' },
      { id: '370400', name: '枣庄市', parentId: '370000', shortName: '枣庄' },
      { id: '370500', name: '东营市', parentId: '370000', shortName: '东营' },
      { id: '370600', name: '烟台市', parentId: '370000', shortName: '烟台' },
      { id: '370700', name: '潍坊市', parentId: '370000', shortName: '潍坊' },
      { id: '370800', name: '济宁市', parentId: '370000', shortName: '济宁' },
      { id: '370900', name: '泰安市', parentId: '370000', shortName: '泰安' },
      { id: '371000', name: '威海市', parentId: '370000', shortName: '威海' },
      { id: '371100', name: '日照市', parentId: '370000', shortName: '日照' },
      { id: '371300', name: '临沂市', parentId: '370000', shortName: '临沂' },
      { id: '371400', name: '德州市', parentId: '370000', shortName: '德州' },
      { id: '371500', name: '聊城市', parentId: '370000', shortName: '聊城' },
      { id: '371600', name: '滨州市', parentId: '370000', shortName: '滨州' },
      { id: '371700', name: '菏泽市', parentId: '370000', shortName: '菏泽' }
    ],
    '410000': [
      { id: '410100', name: '郑州市', parentId: '410000', shortName: '郑州' },
      { id: '410200', name: '开封市', parentId: '410000', shortName: '开封' },
      { id: '410300', name: '洛阳市', parentId: '410000', shortName: '洛阳' },
      { id: '410400', name: '平顶山市', parentId: '410000', shortName: '平顶山' },
      { id: '410500', name: '安阳市', parentId: '410000', shortName: '安阳' },
      { id: '410600', name: '鹤壁市', parentId: '410000', shortName: '鹤壁' },
      { id: '410700', name: '新乡市', parentId: '410000', shortName: '新乡' },
      { id: '410800', name: '焦作市', parentId: '410000', shortName: '焦作' },
      { id: '410900', name: '濮阳市', parentId: '410000', shortName: '濮阳' },
      { id: '411000', name: '许昌市', parentId: '410000', shortName: '许昌' },
      { id: '411100', name: '漯河市', parentId: '410000', shortName: '漯河' },
      { id: '411200', name: '三门峡市', parentId: '410000', shortName: '三门峡' },
      { id: '411300', name: '南阳市', parentId: '410000', shortName: '南阳' },
      { id: '411400', name: '商丘市', parentId: '410000', shortName: '商丘' },
      { id: '411500', name: '信阳市', parentId: '410000', shortName: '信阳' },
      { id: '411600', name: '周口市', parentId: '410000', shortName: '周口' },
      { id: '411700', name: '驻马店市', parentId: '410000', shortName: '驻马店' },
      { id: '419000', name: '省直辖县级行政区划', parentId: '410000', shortName: '省直辖' }
    ],
    '420000': [
      { id: '420100', name: '武汉市', parentId: '420000', shortName: '武汉' },
      { id: '420200', name: '黄石市', parentId: '420000', shortName: '黄石' },
      { id: '420300', name: '十堰市', parentId: '420000', shortName: '十堰' },
      { id: '420500', name: '宜昌市', parentId: '420000', shortName: '宜昌' },
      { id: '420600', name: '襄阳市', parentId: '420000', shortName: '襄阳' },
      { id: '420700', name: '鄂州市', parentId: '420000', shortName: '鄂州' },
      { id: '420800', name: '荆门市', parentId: '420000', shortName: '荆门' },
      { id: '420900', name: '孝感市', parentId: '420000', shortName: '孝感' },
      { id: '421000', name: '荆州市', parentId: '420000', shortName: '荆州' },
      { id: '421100', name: '黄冈市', parentId: '420000', shortName: '黄冈' },
      { id: '421200', name: '咸宁市', parentId: '420000', shortName: '咸宁' },
      { id: '421300', name: '随州市', parentId: '420000', shortName: '随州' },
      { id: '422800', name: '恩施土家族苗族自治州', parentId: '420000', shortName: '恩施' },
      { id: '429000', name: '省直辖县级行政区划', parentId: '420000', shortName: '省直辖' }
    ],
    '430000': [
      { id: '430100', name: '长沙市', parentId: '430000', shortName: '长沙' },
      { id: '430200', name: '株洲市', parentId: '430000', shortName: '株洲' },
      { id: '430300', name: '湘潭市', parentId: '430000', shortName: '湘潭' },
      { id: '430400', name: '衡阳市', parentId: '430000', shortName: '衡阳' },
      { id: '430500', name: '邵阳市', parentId: '430000', shortName: '邵阳' },
      { id: '430600', name: '岳阳市', parentId: '430000', shortName: '岳阳' },
      { id: '430700', name: '常德市', parentId: '430000', shortName: '常德' },
      { id: '430800', name: '张家界市', parentId: '430000', shortName: '张家界' },
      { id: '430900', name: '益阳市', parentId: '430000', shortName: '益阳' },
      { id: '431000', name: '郴州市', parentId: '430000', shortName: '郴州' },
      { id: '431100', name: '永州市', parentId: '430000', shortName: '永州' },
      { id: '431200', name: '怀化市', parentId: '430000', shortName: '怀化' },
      { id: '431300', name: '娄底市', parentId: '430000', shortName: '娄底' },
      { id: '433100', name: '湘西土家族苗族自治州', parentId: '430000', shortName: '湘西' }
    ],
    '440000': [
      { id: '440100', name: '广州市', parentId: '440000', shortName: '广州' },
      { id: '440200', name: '韶关市', parentId: '440000', shortName: '韶关' },
      { id: '440300', name: '深圳市', parentId: '440000', shortName: '深圳' },
      { id: '440400', name: '珠海市', parentId: '440000', shortName: '珠海' },
      { id: '440500', name: '汕头市', parentId: '440000', shortName: '汕头' },
      { id: '440600', name: '佛山市', parentId: '440000', shortName: '佛山' },
      { id: '440700', name: '江门市', parentId: '440000', shortName: '江门' },
      { id: '440800', name: '湛江市', parentId: '440000', shortName: '湛江' },
      { id: '440900', name: '茂名市', parentId: '440000', shortName: '茂名' },
      { id: '441200', name: '肇庆市', parentId: '440000', shortName: '肇庆' },
      { id: '441300', name: '惠州市', parentId: '440000', shortName: '惠州' },
      { id: '441400', name: '梅州市', parentId: '440000', shortName: '梅州' },
      { id: '441500', name: '汕尾市', parentId: '440000', shortName: '汕尾' },
      { id: '441600', name: '河源市', parentId: '440000', shortName: '河源' },
      { id: '441700', name: '阳江市', parentId: '440000', shortName: '阳江' },
      { id: '441800', name: '清远市', parentId: '440000', shortName: '清远' },
      { id: '441900', name: '东莞市', parentId: '440000', shortName: '东莞' },
      { id: '442000', name: '中山市', parentId: '440000', shortName: '中山' },
      { id: '445100', name: '潮州市', parentId: '440000', shortName: '潮州' },
      { id: '445200', name: '揭阳市', parentId: '440000', shortName: '揭阳' },
      { id: '445300', name: '云浮市', parentId: '440000', shortName: '云浮' }
    ],
    '450000': [
      { id: '450100', name: '南宁市', parentId: '450000', shortName: '南宁' },
      { id: '450200', name: '柳州市', parentId: '450000', shortName: '柳州' },
      { id: '450300', name: '桂林市', parentId: '450000', shortName: '桂林' },
      { id: '450400', name: '梧州市', parentId: '450000', shortName: '梧州' },
      { id: '450500', name: '北海市', parentId: '450000', shortName: '北海' },
      { id: '450600', name: '防城港市', parentId: '450000', shortName: '防城港' },
      { id: '450700', name: '钦州市', parentId: '450000', shortName: '钦州' },
      { id: '450800', name: '贵港市', parentId: '450000', shortName: '贵港' },
      { id: '450900', name: '玉林市', parentId: '450000', shortName: '玉林' },
      { id: '451000', name: '百色市', parentId: '450000', shortName: '百色' },
      { id: '451100', name: '贺州市', parentId: '450000', shortName: '贺州' },
      { id: '451200', name: '河池市', parentId: '450000', shortName: '河池' },
      { id: '451300', name: '来宾市', parentId: '450000', shortName: '来宾' },
      { id: '451400', name: '崇左市', parentId: '450000', shortName: '崇左' }
    ],
    '460000': [
      { id: '460100', name: '海口市', parentId: '460000', shortName: '海口' },
      { id: '460200', name: '三亚市', parentId: '460000', shortName: '三亚' },
      { id: '460300', name: '三沙市', parentId: '460000', shortName: '三沙' },
      { id: '460400', name: '儋州市', parentId: '460000', shortName: '儋州' },
      { id: '469000', name: '省直辖县级行政区划', parentId: '460000', shortName: '省直辖' }
    ],
    '500000': [
      { id: '500100', name: '重庆市', parentId: '500000', shortName: '重庆' }
    ],
    '510000': [
      { id: '510100', name: '成都市', parentId: '510000', shortName: '成都' },
      { id: '510300', name: '自贡市', parentId: '510000', shortName: '自贡' },
      { id: '510400', name: '攀枝花市', parentId: '510000', shortName: '攀枝花' },
      { id: '510500', name: '泸州市', parentId: '510000', shortName: '泸州' },
      { id: '510600', name: '德阳市', parentId: '510000', shortName: '德阳' },
      { id: '510700', name: '绵阳市', parentId: '510000', shortName: '绵阳' },
      { id: '510800', name: '广元市', parentId: '510000', shortName: '广元' },
      { id: '510900', name: '遂宁市', parentId: '510000', shortName: '遂宁' },
      { id: '511000', name: '内江市', parentId: '510000', shortName: '内江' },
      { id: '511100', name: '乐山市', parentId: '510000', shortName: '乐山' },
      { id: '511300', name: '南充市', parentId: '510000', shortName: '南充' },
      { id: '511400', name: '眉山市', parentId: '510000', shortName: '眉山' },
      { id: '511500', name: '宜宾市', parentId: '510000', shortName: '宜宾' },
      { id: '511600', name: '广安市', parentId: '510000', shortName: '广安' },
      { id: '511700', name: '达州市', parentId: '510000', shortName: '达州' },
      { id: '511800', name: '雅安市', parentId: '510000', shortName: '雅安' },
      { id: '511900', name: '巴中市', parentId: '510000', shortName: '巴中' },
      { id: '512000', name: '资阳市', parentId: '510000', shortName: '资阳' },
      { id: '513200', name: '阿坝藏族羌族自治州', parentId: '510000', shortName: '阿坝' },
      { id: '513300', name: '甘孜藏族自治州', parentId: '510000', shortName: '甘孜' },
      { id: '513400', name: '凉山彝族自治州', parentId: '510000', shortName: '凉山' }
    ],
    '520000': [
      { id: '520100', name: '贵阳市', parentId: '520000', shortName: '贵阳' },
      { id: '520200', name: '六盘水市', parentId: '520000', shortName: '六盘水' },
      { id: '520300', name: '遵义市', parentId: '520000', shortName: '遵义' },
      { id: '520400', name: '安顺市', parentId: '520000', shortName: '安顺' },
      { id: '520500', name: '毕节市', parentId: '520000', shortName: '毕节' },
      { id: '520600', name: '铜仁市', parentId: '520000', shortName: '铜仁' },
      { id: '522300', name: '黔西南布依族苗族自治州', parentId: '520000', shortName: '黔西南' },
      { id: '522600', name: '黔东南苗族侗族自治州', parentId: '520000', shortName: '黔东南' },
      { id: '522700', name: '黔南布依族苗族自治州', parentId: '520000', shortName: '黔南' }
    ],
    '530000': [
      { id: '530100', name: '昆明市', parentId: '530000', shortName: '昆明' },
      { id: '530300', name: '曲靖市', parentId: '530000', shortName: '曲靖' },
      { id: '530400', name: '玉溪市', parentId: '530000', shortName: '玉溪' },
      { id: '530500', name: '保山市', parentId: '530000', shortName: '保山' },
      { id: '530600', name: '昭通市', parentId: '530000', shortName: '昭通' },
      { id: '530700', name: '丽江市', parentId: '530000', shortName: '丽江' },
      { id: '530800', name: '普洱市', parentId: '530000', shortName: '普洱' },
      { id: '530900', name: '临沧市', parentId: '530000', shortName: '临沧' },
      { id: '532300', name: '楚雄彝族自治州', parentId: '530000', shortName: '楚雄' },
      { id: '532500', name: '红河哈尼族彝族自治州', parentId: '530000', shortName: '红河' },
      { id: '532600', name: '文山壮族苗族自治州', parentId: '530000', shortName: '文山' },
      { id: '532800', name: '西双版纳傣族自治州', parentId: '530000', shortName: '西双版纳' },
      { id: '532900', name: '大理白族自治州', parentId: '530000', shortName: '大理' },
      { id: '533100', name: '德宏傣族景颇族自治州', parentId: '530000', shortName: '德宏' },
      { id: '533300', name: '怒江傈僳族自治州', parentId: '530000', shortName: '怒江' },
      { id: '533400', name: '迪庆藏族自治州', parentId: '530000', shortName: '迪庆' }
    ],
    '540000': [
      { id: '540100', name: '拉萨市', parentId: '540000', shortName: '拉萨' },
      { id: '540200', name: '日喀则市', parentId: '540000', shortName: '日喀则' },
      { id: '540300', name: '昌都市', parentId: '540000', shortName: '昌都' },
      { id: '540400', name: '林芝市', parentId: '540000', shortName: '林芝' },
      { id: '540500', name: '山南市', parentId: '540000', shortName: '山南' },
      { id: '540600', name: '那曲市', parentId: '540000', shortName: '那曲' },
      { id: '542500', name: '阿里地区', parentId: '540000', shortName: '阿里' }
    ],
    '610000': [
      { id: '610100', name: '西安市', parentId: '610000', shortName: '西安' },
      { id: '610200', name: '铜川市', parentId: '610000', shortName: '铜川' },
      { id: '610300', name: '宝鸡市', parentId: '610000', shortName: '宝鸡' },
      { id: '610400', name: '咸阳市', parentId: '610000', shortName: '咸阳' },
      { id: '610500', name: '渭南市', parentId: '610000', shortName: '渭南' },
      { id: '610600', name: '延安市', parentId: '610000', shortName: '延安' },
      { id: '610700', name: '汉中市', parentId: '610000', shortName: '汉中' },
      { id: '610800', name: '榆林市', parentId: '610000', shortName: '榆林' },
      { id: '610900', name: '安康市', parentId: '610000', shortName: '安康' },
      { id: '611000', name: '商洛市', parentId: '610000', shortName: '商洛' }
    ],
    '620000': [
      { id: '620100', name: '兰州市', parentId: '620000', shortName: '兰州' },
      { id: '620200', name: '嘉峪关市', parentId: '620000', shortName: '嘉峪关' },
      { id: '620300', name: '金昌市', parentId: '620000', shortName: '金昌' },
      { id: '620400', name: '白银市', parentId: '620000', shortName: '白银' },
      { id: '620500', name: '天水市', parentId: '620000', shortName: '天水' },
      { id: '620600', name: '武威市', parentId: '620000', shortName: '武威' },
      { id: '620700', name: '张掖市', parentId: '620000', shortName: '张掖' },
      { id: '620800', name: '平凉市', parentId: '620000', shortName: '平凉' },
      { id: '620900', name: '酒泉市', parentId: '620000', shortName: '酒泉' },
      { id: '621000', name: '庆阳市', parentId: '620000', shortName: '庆阳' },
      { id: '621100', name: '定西市', parentId: '620000', shortName: '定西' },
      { id: '621200', name: '陇南市', parentId: '620000', shortName: '陇南' },
      { id: '622900', name: '临夏回族自治州', parentId: '620000', shortName: '临夏' },
      { id: '623000', name: '甘南藏族自治州', parentId: '620000', shortName: '甘南' }
    ],
    '630000': [
      { id: '630100', name: '西宁市', parentId: '630000', shortName: '西宁' },
      { id: '630200', name: '海东市', parentId: '630000', shortName: '海东' },
      { id: '632200', name: '海北藏族自治州', parentId: '630000', shortName: '海北' },
      { id: '632300', name: '黄南藏族自治州', parentId: '630000', shortName: '黄南' },
      { id: '632500', name: '海南藏族自治州', parentId: '630000', shortName: '海南' },
      { id: '632600', name: '果洛藏族自治州', parentId: '630000', shortName: '果洛' },
      { id: '632700', name: '玉树藏族自治州', parentId: '630000', shortName: '玉树' },
      { id: '632800', name: '海西蒙古族藏族自治州', parentId: '630000', shortName: '海西' }
    ],
    '640000': [
      { id: '640100', name: '银川市', parentId: '640000', shortName: '银川' },
      { id: '640200', name: '石嘴山市', parentId: '640000', shortName: '石嘴山' },
      { id: '640300', name: '吴忠市', parentId: '640000', shortName: '吴忠' },
      { id: '640400', name: '固原市', parentId: '640000', shortName: '固原' },
      { id: '640500', name: '中卫市', parentId: '640000', shortName: '中卫' }
    ],
    '650000': [
      { id: '650100', name: '乌鲁木齐市', parentId: '650000', shortName: '乌鲁木齐' },
      { id: '650200', name: '克拉玛依市', parentId: '650000', shortName: '克拉玛依' },
      { id: '650400', name: '吐鲁番市', parentId: '650000', shortName: '吐鲁番' },
      { id: '650500', name: '哈密市', parentId: '650000', shortName: '哈密' },
      { id: '652300', name: '昌吉回族自治州', parentId: '650000', shortName: '昌吉' },
      { id: '652700', name: '博尔塔拉蒙古自治州', parentId: '650000', shortName: '博尔塔拉' },
      { id: '652800', name: '巴音郭楞蒙古自治州', parentId: '650000', shortName: '巴音郭楞' },
      { id: '652900', name: '阿克苏地区', parentId: '650000', shortName: '阿克苏' },
      { id: '653000', name: '克孜勒苏柯尔克孜自治州', parentId: '650000', shortName: '克孜勒苏' },
      { id: '653100', name: '喀什地区', parentId: '650000', shortName: '喀什' },
      { id: '653200', name: '和田地区', parentId: '650000', shortName: '和田' },
      { id: '654000', name: '伊犁哈萨克自治州', parentId: '650000', shortName: '伊犁' },
      { id: '654200', name: '塔城地区', parentId: '650000', shortName: '塔城' },
      { id: '654300', name: '阿勒泰地区', parentId: '650000', shortName: '阿勒泰' },
      { id: '659000', name: '自治区直辖县级行政区划', parentId: '650000', shortName: '自治区直辖' }
    ],
    '710000': [
      { id: '710100', name: '台北市', parentId: '710000', shortName: '台北' },
      { id: '710200', name: '高雄市', parentId: '710000', shortName: '高雄' },
      { id: '710300', name: '基隆市', parentId: '710000', shortName: '基隆' },
      { id: '710400', name: '台中市', parentId: '710000', shortName: '台中' },
      { id: '710500', name: '台南市', parentId: '710000', shortName: '台南' },
      { id: '710600', name: '新竹市', parentId: '710000', shortName: '新竹' },
      { id: '710700', name: '嘉义市', parentId: '710000', shortName: '嘉义' },
      { id: '710800', name: '新北市', parentId: '710000', shortName: '新北' },
      { id: '712200', name: '宜兰县', parentId: '710000', shortName: '宜兰' },
      { id: '712300', name: '桃园县', parentId: '710000', shortName: '桃园' },
      { id: '712400', name: '新竹县', parentId: '710000', shortName: '新竹' },
      { id: '712500', name: '苗栗县', parentId: '710000', shortName: '苗栗' },
      { id: '712700', name: '彰化县', parentId: '710000', shortName: '彰化' },
      { id: '712800', name: '南投县', parentId: '710000', shortName: '南投' },
      { id: '712900', name: '云林县', parentId: '710000', shortName: '云林' },
      { id: '713000', name: '嘉义县', parentId: '710000', shortName: '嘉义' },
      { id: '713300', name: '屏东县', parentId: '710000', shortName: '屏东' },
      { id: '713400', name: '台东县', parentId: '710000', shortName: '台东' },
      { id: '713500', name: '花莲县', parentId: '710000', shortName: '花莲' },
      { id: '713600', name: '澎湖县', parentId: '710000', shortName: '澎湖' },
      { id: '713700', name: '金门县', parentId: '710000', shortName: '金门' },
      { id: '713800', name: '连江县', parentId: '710000', shortName: '连江' }
    ],
    '810000': [
      { id: '810100', name: '香港特别行政区', parentId: '810000', shortName: '香港' }
    ],
    '820000': [
      { id: '820100', name: '澳门特别行政区', parentId: '820000', shortName: '澳门' }
    ]
  }
};

// 主要功能类
class CitySelector {
  constructor() {
    this.provinces = chinaCityData.provinces;
    this.cities = chinaCityData.cities;
  }

  /**
   * 获取所有省份列表
   * @returns {Array} 省份数组
   */
  getProvinces() {
    return this.provinces;
  }

  /**
   * 根据省份ID获取城市列表
   * @param {string} provinceId - 省份ID
   * @returns {Array} 城市数组
   */
  getCitiesByProvince(provinceId) {
    return this.cities[provinceId] || [];
  }

  /**
   * 获取指定格式的省市数据
   * @param {string} format - 输出格式 ('array'|'object'|'tree')
   * @returns {*} 格式化的数据
   */
  getFormattedData(format = 'array') {
    switch (format) {
      case 'array':
        return this.getArrayFormat();
      case 'object':
        return this.getObjectFormat();
      case 'tree':
        return this.getTreeFormat();
      default:
        return this.getArrayFormat();
    }
  }

  /**
   * 数组格式输出
   * @returns {Array} 扁平化数组格式
   */
  getArrayFormat() {
    const result = [];
    
    this.provinces.forEach(province => {
      result.push({
        id: province.id,
        name: province.name,
        shortName: province.shortName,
        type: 'province',
        parentId: null
      });
      
      const cities = this.getCitiesByProvince(province.id);
      cities.forEach(city => {
        result.push({
          id: city.id,
          name: city.name,
          shortName: city.shortName,
          type: 'city',
          parentId: province.id
        });
      });
    });
    
    return result;
  }

  /**
   * 对象格式输出
   * @returns {Object} 对象格式 {provinceId: {province, cities}}
   */
  getObjectFormat() {
    const result = {};
    
    this.provinces.forEach(province => {
      const cities = this.getCitiesByProvince(province.id);
      result[province.id] = {
        province: province,
        cities: cities
      };
    });
    
    return result;
  }

  /**
   * 树形结构输出
   * @returns {Array} 树形结构数组
   */
  getTreeFormat() {
    return this.provinces.map(province => {
      return {
        id: province.id,
        name: province.name,
        shortName: province.shortName,
        type: 'province',
        children: this.getCitiesByProvince(province.id).map(city => ({
          id: city.id,
          name: city.name,
          shortName: city.shortName,
          type: 'city',
          parentId: province.id
        }))
      };
    });
  }

  /**
   * 根据ID查找地区信息
   * @param {string} id - 地区ID
   * @returns {Object|null} 地区信息对象
   */
  findById(id) {
    // 先在省份中查找
    const province = this.provinces.find(p => p.id === id);
    if (province) {
      return {
        ...province,
        type: 'province'
      };
    }
    
    // 在城市中查找
    for (let provinceId in this.cities) {
      const city = this.cities[provinceId].find(c => c.id === id);
      if (city) {
        return {
          ...city,
          type: 'city',
          provinceId: provinceId
        };
      }
    }
    
    return null;
  }

  /**
   * 根据名称查找地区（支持模糊匹配）
   * @param {string} name - 地区名称
   * @param {string} type - 类型 ('province'|'city'|'all')
   * @returns {Array} 匹配的地区数组
   */
  findByName(name, type = 'all') {
    const results = [];
    
    if (type === 'province' || type === 'all') {
      this.provinces.forEach(province => {
        if (province.name.includes(name) || province.shortName.includes(name)) {
          results.push({
            ...province,
            type: 'province'
          });
        }
      });
    }
    
    if (type === 'city' || type === 'all') {
      for (let provinceId in this.cities) {
        this.cities[provinceId].forEach(city => {
          if (city.name.includes(name) || city.shortName.includes(name)) {
            results.push({
              ...city,
              type: 'city',
              provinceId: provinceId
            });
          }
        });
      }
    }
    
    return results;
  }

  /**
   * 获取热门城市列表
   * @returns {Array} 热门城市数组
   */
  getHotCities() {
    const hotCityIds = [
      '110100', // 北京
      '310100', // 上海
      '440100', // 广州
      '440300', // 深圳
      '320100', // 南京
      '330100', // 杭州
      '510100', // 成都
      '420100', // 武汉
      '120100', // 天津
      '500100'  // 重庆
    ];
    
    return hotCityIds.map(id => this.findById(id)).filter(Boolean);
  }

  /**
   * 获取拼音首字母索引
   * @returns {Object} 按拼音首字母分组的对象
   */
  getPinyinIndex() {
    // 简化的拼音映射（实际项目中建议使用 pinyin-pro 库）
    const pinyinMap = {
      '北京': 'B', '天津': 'T', '河北': 'H', '山西': 'S', '内蒙古': 'N',
      '辽宁': 'L', '吉林': 'J', '黑龙江': 'H', '上海': 'S', '江苏': 'J',
      '浙江': 'Z', '安徽': 'A', '福建': 'F', '江西': 'J', '山东': 'S',
      '河南': 'H', '湖北': 'H', '湖南': 'H', '广东': 'G', '广西': 'G',
      '海南': 'H', '重庆': 'C', '四川': 'S', '贵州': 'G', '云南': 'Y',
      '西藏': 'X', '陕西': 'S', '甘肃': 'G', '青海': 'Q', '宁夏': 'N',
      '新疆': 'X', '台湾': 'T', '香港': 'X', '澳门': 'A'
    };
    
    const result = {};
    
    this.provinces.forEach(province => {
      const firstLetter = pinyinMap[province.shortName] || province.shortName.charAt(0);
      if (!result[firstLetter]) {
        result[firstLetter] = [];
      }
      result[firstLetter].push({
        ...province,
        type: 'province'
      });
    });
    
    return result;
  }
}

// 创建实例并导出
const citySelector = new CitySelector();

// 导出常用方法
export default {
  // 获取实例
  getInstance: () => citySelector,
  
  // 直接调用的方法
  getProvinces: () => citySelector.getProvinces(),
  getCitiesByProvince: (provinceId) => citySelector.getCitiesByProvince(provinceId),
  getFormattedData: (format) => citySelector.getFormattedData(format),
  findById: (id) => citySelector.findById(id),
  findByName: (name, type) => citySelector.findByName(name, type),
  getHotCities: () => citySelector.getHotCities(),
  getPinyinIndex: () => citySelector.getPinyinIndex(),
  
  // 便捷方法
  /**
   * 获取省市联动数据（Element UI Cascader 组件格式）
   * @returns {Array} 级联选择器数据
   */
  getCascaderData: () => {
    return citySelector.provinces.map(province => ({
      value: province.id,
      label: province.name,
      children: citySelector.getCitiesByProvince(province.id).map(city => ({
        value: city.id,
        label: city.name
      }))
    }));
  },
  
  /**
   * 获取省市选项数据（用于 Select 组件）
   * @param {string} type - 'province'|'city'|'both'
   * @param {string} provinceId - 当type为city时需要指定省份ID
   * @returns {Array} 选项数组
   */
  getOptions: (type = 'province', provinceId = null) => {
    switch (type) {
      case 'province':
        return citySelector.provinces.map(province => ({
          value: province.id,
          label: province.name
        }));
      case 'city':
        if (!provinceId) return [];
        return citySelector.getCitiesByProvince(provinceId).map(city => ({
          value: city.id,
          label: city.name
        }));
      case 'both':
        // 返回带分组的选项
        const options = [];
        citySelector.provinces.forEach(province => {
          options.push({
            value: province.id,
            label: province.name,
            disabled: true
          });
          
          const cities = citySelector.getCitiesByProvince(province.id);
          cities.forEach(city => {
            options.push({
              value: city.id,
              label: `　${city.name}`, // 添加缩进
              parentId: province.id
            });
          });
        });
        return options;
      default:
        return [];
    }
  },
  
  /**
   * 将省市ID转换为完整名称
   * @param {string} provinceId - 省份ID
   * @param {string} cityId - 城市ID
   * @returns {string} 完整名称（如：北京市/上海市）
   */
  formatFullAddress: (provinceId, cityId = null) => {
    const province = citySelector.findById(provinceId);
    if (!province) return '';
    
    if (cityId) {
      const city = citySelector.findById(cityId);
      return city ? `${province.name}/${city.name}` : province.name;
    }
    
    return province.name;
  },
  
  /**
   * 验证省市ID的有效性
   * @param {string} provinceId - 省份ID
   * @param {string} cityId - 城市ID
   * @returns {Object} 验证结果
   */
  validateIds: (provinceId, cityId = null) => {
    const result = {
      isValid: true,
      errors: []
    };
    
    const province = citySelector.findById(provinceId);
    if (!province) {
      result.isValid = false;
      result.errors.push(`无效的省份ID: ${provinceId}`);
    }
    
    if (cityId) {
      const city = citySelector.findById(cityId);
      if (!city) {
        result.isValid = false;
        result.errors.push(`无效的城市ID: ${cityId}`);
      } else if (city.provinceId !== provinceId) {
        result.isValid = false;
        result.errors.push(`城市ID与省份ID不匹配`);
      }
    }
    
    return result;
  }
};

// 如果在浏览器环境中，也挂载到全局对象
if (typeof window !== 'undefined') {
  window.CitySelector = {
    getInstance: () => citySelector,
    getProvinces: () => citySelector.getProvinces(),
    getCitiesByProvince: (provinceId) => citySelector.getCitiesByProvince(provinceId),
    getFormattedData: (format) => citySelector.getFormattedData(format),
    findById: (id) => citySelector.findById(id),
    findByName: (name, type) => citySelector.findByName(name, type),
    getHotCities: () => citySelector.getHotCities(),
    getPinyinIndex: () => citySelector.getPinyinIndex(),
    getCascaderData: () => {
      return citySelector.provinces.map(province => ({
        value: province.id,
        label: province.name,
        children: citySelector.getCitiesByProvince(province.id).map(city => ({
          value: city.id,
          label: city.name
        }))
      }));
    },
    getOptions: (type = 'province', provinceId = null) => {
      switch (type) {
        case 'province':
          return citySelector.provinces.map(province => ({
            value: province.id,
            label: province.name
          }));
        case 'city':
          if (!provinceId) return [];
          return citySelector.getCitiesByProvince(provinceId).map(city => ({
            value: city.id,
            label: city.name
          }));
        case 'both':
          const options = [];
          citySelector.provinces.forEach(province => {
            options.push({
              value: province.id,
              label: province.name,
              disabled: true
            });
            
            const cities = citySelector.getCitiesByProvince(province.id);
            cities.forEach(city => {
              options.push({
                value: city.id,
                label: `　${city.name}`,
                parentId: province.id
              });
            });
          });
          return options;
        default:
          return [];
      }
    },
    formatFullAddress: (provinceId, cityId = null) => {
      const province = citySelector.findById(provinceId);
      if (!province) return '';
      
      if (cityId) {
        const city = citySelector.findById(cityId);
        return city ? `${province.name}/${city.name}` : province.name;
      }
      
      return province.name;
    },
    validateIds: (provinceId, cityId = null) => {
      const result = {
        isValid: true,
        errors: []
      };
      
      const province = citySelector.findById(provinceId);
      if (!province) {
        result.isValid = false;
        result.errors.push(`无效的省份ID: ${provinceId}`);
      }
      
      if (cityId) {
        const city = citySelector.findById(cityId);
        if (!city) {
          result.isValid = false;
          result.errors.push(`无效的城市ID: ${cityId}`);
        } else if (city.provinceId !== provinceId) {
          result.isValid = false;
          result.errors.push(`城市ID与省份ID不匹配`);
        }
      }
      
      return result;
    }
  };
}

// Node.js 环境下的模块导出
if (typeof module !== 'undefined' && module.exports) {
  module.exports = {
    getInstance: () => citySelector,
    getProvinces: () => citySelector.getProvinces(),
    getCitiesByProvince: (provinceId) => citySelector.getCitiesByProvince(provinceId),
    getFormattedData: (format) => citySelector.getFormattedData(format),
    findById: (id) => citySelector.findById(id),
    findByName: (name, type) => citySelector.findByName(name, type),
    getHotCities: () => citySelector.getHotCities(),
    getPinyinIndex: () => citySelector.getPinyinIndex(),
    getCascaderData: () => {
      return citySelector.provinces.map(province => ({
        value: province.id,
        label: province.name,
        children: citySelector.getCitiesByProvince(province.id).map(city => ({
          value: city.id,
          label: city.name
        }))
      }));
    },
    getOptions: (type = 'province', provinceId = null) => {
      switch (type) {
        case 'province':
          return citySelector.provinces.map(province => ({
            value: province.id,
            label: province.name
          }));
        case 'city':
          if (!provinceId) return [];
          return citySelector.getCitiesByProvince(provinceId).map(city => ({
            value: city.id,
            label: city.name
          }));
        case 'both':
          const options = [];
          citySelector.provinces.forEach(province => {
            options.push({
              value: province.id,
              label: province.name,
              disabled: true
            });
            
            const cities = citySelector.getCitiesByProvince(province.id);
            cities.forEach(city => {
              options.push({
                value: city.id,
                label: `　${city.name}`,
                parentId: province.id
              });
            });
          });
          return options;
        default:
          return [];
      }
    },
    formatFullAddress: (provinceId, cityId = null) => {
      const province = citySelector.findById(provinceId);
      if (!province) return '';
      
      if (cityId) {
        const city = citySelector.findById(cityId);
        return city ? `${province.name}/${city.name}` : province.name;
      }
      
      return province.name;
    },
    validateIds: (provinceId, cityId = null) => {
      const result = {
        isValid: true,
        errors: []
      };
      
      const province = citySelector.findById(provinceId);
      if (!province) {
        result.isValid = false;
        result.errors.push(`无效的省份ID: ${provinceId}`);
      }
      
      if (cityId) {
        const city = citySelector.findById(cityId);
        if (!city) {
          result.isValid = false;
          result.errors.push(`无效的城市ID: ${cityId}`);
        } else if (city.provinceId !== provinceId) {
          result.isValid = false;
          result.errors.push(`城市ID与省份ID不匹配`);
        }
      }
      
      return result;
    }
  };
}


// WEBPACK FOOTER //
// ./src/assets/js/citys.js